import React, { CSSProperties } from 'react';

// Map MaterialCommunityIcons names to Unicode/emoji equivalents for web
const iconMap: Record<string, string> = {
  'email': '📧',
  'key-variant': '🔑',
  'file-sign': '📝',
  'eye': '👁️',
  'eye-off': '🙈',
};

interface IconProps {
  name: string;
  size?: number;
  color?: string;
  style?: CSSProperties;
}

export const Icon = ({ name, size = 24, color, style }: IconProps) => {
  const iconStyle: CSSProperties = {
    fontSize: `${size}px`,
    color: color,
    display: 'inline-block',
    lineHeight: 1,
    ...style,
  };

  const iconChar = iconMap[name] || '❓';

  return <span style={iconStyle}>{iconChar}</span>;
};
